<section class="home-precios" id="precios">
  <div class="home-precios__inner">
    <h2 class="home-precios__title">Un precio. Sin tramos. Sin sorpresas.</h2>
    <p class="home-precios__sub">
      Empiezas por la base y añades solo lo que necesites.
      <strong>Operativos ilimitados, siempre.</strong>
    </p>

    <!-- Toggle mensual / anual -->
    <div class="home-precios__billing">
      <div class="billing-toggle" role="group" aria-label="Periodicidad">
        <button
          type="button"
          class="billing-toggle__opt"
          [class.is-active]="billing() === 'monthly'"
          (click)="setBilling('monthly')">
          Mensual
        </button>
        <button
          type="button"
          class="billing-toggle__opt"
          [class.is-active]="billing() === 'annual'"
          (click)="setBilling('annual')">
          Anual
        </button>
      </div>
      <span class="home-precios__save">Dos meses sin coste</span>
    </div>

    <div class="home-precios__grid">
      <!-- Base -->
      <article class="plan-base">
        <div class="plan-base__label">Esencial</div>
        <div class="plan-base__price">
          <span class="plan-base__amount">{{ amountText() }}€</span>
          <span class="plan-base__per">{{ perText() }}</span>
        </div>
        <div class="plan-base__subline">{{ subline() }}</div>

        <ul class="plan-base__features">
          @for (f of features; track f; let first = $first) {
            <li>
              <span class="plan-base__check" aria-hidden="true">✓</span>
              @if (first) {
                <strong>{{ f }}</strong>
              } @else {
                {{ f }}
              }
            </li>
          }
        </ul>

        <a routerLink="/prueba-sin-compromiso" class="plan-base__cta">
          Empieza la prueba de 14 días
        </a>
      </article>

      <!-- Ampliaciones -->
      <aside class="addons">
        <div class="addons__title">Amplía cuando lo necesites</div>
        <p class="addons__sub">Sobre la base, sin tramos ni saltos de precio.</p>
        <div class="addons__list">
          @for (a of addons; track a.name) {
            <div class="addons__row">
              <div class="addons__info">
                <div class="addons__name">{{ a.name }}</div>
                <div class="addons__desc">{{ a.desc }}</div>
              </div>
              <span class="addons__price">{{ a.price }}</span>
            </div>
          }
        </div>
      </aside>
    </div>

    <!-- Ancla de precio: Consejo de Estado -->
    <p class="home-precios__anchor">
      El Consejo de Estado cifra en <strong>55,40 €/mes</strong> el coste medio
      de adoptar un fichaje digital legal. Con TodoSector tienes fichaje,
      facturación y plataforma por 45 € — y con operativos ilimitados.
    </p>
  </div>
</section>
